import React from 'react';
import { Col, Row, Alert } from 'reactstrap';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import NFButton from '../../primitives/NFButton';
import msgs from '../../../config/messages';
// import orgDetailsConfig from './formConfig';
import { orgDetailsConfig, contactConfig } from './formConfig';
import './EditOrganization.scss';

export default class EditOrganization extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onResetForm: PropTypes.func.isRequired,
    initialValues: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      status: PropTypes.string,
      address1: PropTypes.string,
      address2: PropTypes.string,
      address3: PropTypes.string,
      zipCode: PropTypes.string,
      pointofContact: PropTypes.string,
      phoneNumber: PropTypes.string,
      organizationType: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      websiteUrl: PropTypes.string,
    }),
    onCountryChange: PropTypes.func.isRequired,
    onStateProvChange: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    alertType: PropTypes.string.isRequired,
    alertMessage: PropTypes.string.isRequired,
  };

  static defaultProps = {
    initialValues: {
      id: '',
      name: '',
      status: '',
      address1: '',
      address2: '',
      address3: '',
      zipCode: '',
      pointofContact: '',
      phoneNumber: '',
      organizationType: '',
      city: '',
      state: '',
      websiteUrl: '',
    },
  };

  render() {
    const { onSubmit, initialValues, alertType, alertMessage, onCountryChange, onStateProvChange, onFieldChange, onResetForm } = this.props;

    let isSamsCageCode = true
    if (initialValues.cageCode.charAt(0) === "O") {
      isSamsCageCode = false
    }

    return (
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        isSamsCageCode={isSamsCageCode}
        render={({ handleSubmit, invalid, submitting }) => (
          <form className="nf-new-org-form" onSubmit={handleSubmit}>
            <br />
            {alertMessage && <Alert color={alertType}>{alertMessage}</Alert>}
            {isSamsCageCode && <div className="nf-org-message">
              If your organization is registered with the System for Award Management (SAM) then you will need to sign into <a href='https://www.sam.gov' rel='noopener noreferrer' target='_blank'>sam.gov</a> to make changes to your organization and contact details.
            </div>}
            <div>
              <h3 className="nf-add-organization__header">
                Organization Details<div className="nf-org-status">Current Status: {initialValues.iconStatus}</div>
              </h3>
              {orgDetailsConfig.map(fieldConfig => (
                // fieldconfig settings will overide disabled setting here.
                <Field
                  key={fieldConfig.name}
                  disabled={isSamsCageCode}
                  onCountryChange={onCountryChange}
                  onStateProvChange={onStateProvChange}
                  cntry={initialValues.cntry}
                  parse={value => value}
                  onBlur={(e) => { onFieldChange(fieldConfig.name, e.target.value) }}
                  {...fieldConfig}
                />
              ))}
              <br />
              <h3 className="nf-add-organization__header">
                Contact Details
              </h3>
              {contactConfig.map(fieldConfig => (
                <Field key={fieldConfig.name}
                  disabled={isSamsCageCode}
                  parse={value => value}
                  onBlur={(e) => { onFieldChange(fieldConfig.name, e.target.value) }}
                  {...fieldConfig} />
              ))}

              <Row>
                <Col sm={{ size: 7, offset: 2 }} className="text-center">
                  <NFButton
                    className="nf-button--gray-border"
                    disabled={submitting}
                    onClick={() => {
                      onResetForm();
                    }}
                  >
                    Reset
                  </NFButton>
                  <NFButton
                    className="nf-button--form nf-button--orange"
                    type="submit"
                    disabled={invalid || submitting}
                  >
                    {msgs.Form.submitButton}
                  </NFButton>
                </Col>
              </Row>
            </div>
          </form>
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/EditOrganizationForm/EditOrganization.jsx